import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadsTabSoLineItemsQueryAtom = createQueryAtomFactory(
  'trade.loadsTabSoLineItems',
  (params: { salesOrderIds: string[] }) => ({
    salesOrders: {
      __args: {
        filter: {
          includeLineItems: true,
          ids: params.salesOrderIds,
        },
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      entries: {
        id: true,
        lineItems: {
          item: {
            id: true,
          },
        },
      },
    },
  }),
  {
    select: (data): Record<string, string[]> =>
      Object.fromEntries(
        (data?.salesOrders?.entries ?? []).map((so) => [
          so.id,
          [
            ...new Set(
              (so.lineItems ?? [])
                .map((li) => li.item?.id)
                .filter((id): id is string => !!id),
            ),
          ],
        ]),
      ),
  },
);
